module.exports = __webpack_public_path__ + "static/media/editar.611a09d0.svg";